import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { signUp } from "../firebase/auth";
import { USE_REAL_FIREBASE } from "../firebase/config";

const RegisterScreen = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { setMockUser } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      setLoading(false);
      return;
    }

    try {
      const result = await signUp(
        email.trim(),
        password,
        displayName.trim() || email.split("@")[0]
      );

      if (!result.success) {
        setError(result.error || "Failed to create account. Please try again.");
        return;
      }

      if (result.requiresEmailVerification) {
        setSuccess(
          "Account created. We sent a verification email — please verify your address, then sign in."
        );
        setTimeout(() => navigate("/login"), 2500);
        return;
      }

      if (!USE_REAL_FIREBASE) {
        setMockUser(result.user);
      }

      navigate("/");
    } catch (registerError) {
      setError("Failed to create account. Please try again.");
      console.error("Registration error:", registerError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="screen"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="register-header" style={{ textAlign: "center", marginTop: 48 }}>
        <h1 className="screen-title">Create Account</h1>
        <p className="screen-subtitle" style={{ marginBottom: 40 }}>
          Start your investing journey
        </p>
      </div>
      <div className="form-container" style={{ maxWidth: 440, width: "100%" }}>
        {error && (
          <div
            className="card"
            style={{
              background: "#EF4444",
              color: "white",
              marginBottom: "20px",
            }}
          >
            {error}
          </div>
        )}
        {success && (
          <div
            className="card"
            style={{
              background: "rgba(34, 197, 94, 0.15)",
              color: "#86efac",
              marginBottom: "20px",
              border: "1px solid rgba(34, 197, 94, 0.35)",
            }}
          >
            {success}
          </div>
        )}

        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-input"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Enter your name"
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your password"
              required
              autoComplete="new-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-large w-full"
            disabled={loading}
          >
            {loading ? "Creating Account..." : "Create Account"}
          </button>
        </form>

        <div className="text-center mt-3">
          <p style={{ color: "#94A3B8" }}>
            Already have an account?{" "}
            <Link to="/login" style={{ color: "#3B82F6", textDecoration: "none" }}>
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterScreen;
